<template>
    <div class="d-flex flex-row align-items-center user-select-none">
        <div class="mr-8">
            <span class="spinner d-inline-block" :class="spinnerClass"/>
        </div>
        <div class="pt-3 font-size-h6 font-weight-light">
            <slot/>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        spinnerClass: {
            type: String,
            default: 'spinner-secondary'
        }
    }
}
</script>
